import PaddleOutlined from '../../src/legacy/PaddleOutlined';
export default PaddleOutlined;
